import React, { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Container,
  Button,
} from 'reactstrap';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar expand="md" className="navigation" light>
      <Container className="d-flex align-items-center">
        <NavbarBrand href="/" className="d-flex align-items-center">
          <img
            src={require('../../../assets/images/logo-dark.png')}
            alt="SOS Dottore"
            className="navigation__logo"
          />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse
          isOpen={isOpen}
          navbar
          className="d-md-flex align-items-center">
          {/* <Nav className="mx-auto d-md-flex align-items-center" navbar>
            <NavItem>
              <NavLink href="#servizi">Servizi</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#come-funziona">Come Funziona</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#prezzi">Prezzi</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#contatti">Contatti</NavLink>
            </NavItem>
          </Nav> */}
          <Nav className="ml-auto d-md-flex align-items-center" navbar>
            <NavItem className="d-flex align-items-center">
              <Button
                color="primary"
                className="ml-md-3 mr-md-3 mr-3"
                onClick={() => {
                  window.location.href = '#pricing';
                }}>
                Abbonati ora
              </Button>
              <Button
                color="secondary"
                outline
                className="ml-md-3"
                onClick={() => {
                  window.location.href = '/login';
                }}>
                <i className="fa fa-fw fa-user mr-2"></i>
                Accedi
              </Button>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
